import React from 'react';
import AppVersionManager from '../components/admin/AppVersionManager';

const AppVersionsPage = () => {
  return (
    <div className="p-6">
      <AppVersionManager />
    </div>
  );
};

export default AppVersionsPage;
